import React from 'react'

const AutofillFocusContext = React.createContext(null)

export const useAutofillFocus = () => React.useContext(AutofillFocusContext)

export default AutofillFocusContext
